import { MovementType } from "@/data/movementType";

/**
 * Type for the category option structure
 */
export type MovementsBySection = {
  section_name: string;
  movements: MovementType[];
};

/**
 * Default category options used across the application
 */
export const DEFAULT_MOVEMENTS_BY_SECTION: MovementsBySection[] = [
  {
    section_name: "account_fees",
    movements: [MovementType.FEES],
  },
  {
    section_name: "loan_flows",
    movements: [
      MovementType.HOME_LOAN,
      MovementType.OTHER_LOAN,
      MovementType.INTEREST,
    ],
  },
  {
    section_name: "revenue",
    movements: [MovementType.DIVIDEND, MovementType.ACCRUED_INTEREST],
  },
  {
    section_name: "unlisted_asset_funds",
    movements: [
      MovementType.CAPITAL_CALL,
      MovementType.CAPITAL_GAIN,
      MovementType.RETURN_EXCESS_CALL,
      MovementType.CALL_SUBSEQUENT_CLOSING,
      MovementType.DISTRIBUTION,
      MovementType.RETURN_EXCESS_DISTRIBUTION,
      MovementType.RETURN_EXCESS_TEMPORARY_DISTRIBUTION,
      MovementType.DISTRIBUTION_SUBSEQUENT_CLOSING,
      MovementType.TEMPORARY_RETURN_CAPITAL,
      MovementType.TRANSFER_FUND_REALLOCATION,
      MovementType.FEEDER_FEE,
    ],
  },
];

type MovementMap = {
  security: Record<
    string,
    MovementType[] | Record<"pos" | "neg", MovementType[]>
  >;
  cash: Record<string, MovementType[]>;
  cash_special_case: Record<string, MovementType[]>;
};

export const DEFAULT_MOVEMENT_MAP: MovementMap = {
  security: {},
  cash: {
    equity: [MovementType.DIVIDEND],
    group: [MovementType.DIVIDEND],
    cash: [MovementType.DIVIDEND],
    fixed_income: [MovementType.ACCRUED_INTEREST],
    private_debt: [MovementType.OTHER_LOAN, MovementType.INTEREST],
  },
  cash_special_case: {
    "*": [MovementType.FEES],
  },
};

export const AUTOMATIC_TAG_MAP: string[] = [MovementType.CASH];
